export function getLoginCred(platform: string): string {
  if (platform === "google") {
    return process.env.REACT_APP_GOOGLE_LOGIN_CRED || "";
  } else {
    return "";
  }
}
